import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TitularesTable() {
  const [titulares, setTitulares] = useState([]);
  const [filteredTitulares, setFilteredTitulares] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTercero, setSelectedTercero] = useState(null);
  const [searchSepulturaId, setSearchSepulturaId] = useState('');
  
  const [pageBlock, setPageBlock] = useState(0); // Cada bloque tiene 10 páginas
  const pagesPerBlock = 10;
  const itemsPerPage = 10;

  useEffect(() => {
    fetchTitulares();
    fetchTerceros();
  }, []);

  /*
  useEffect(() => {
    filterTitulares();
  }, [searchTerm, searchTercero, searchStartDate, searchEndDate, titulares]);
*/

  useEffect(() => {
    filterTitulares();
  }, [searchTerm, searchTercero, searchStartDate, searchEndDate, searchSepulturaId, titulares]);
  

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchTitulares = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/titulares');
      setTitulares(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los titulares. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterTitulares = () => {
    let filtered = titulares.filter(titular =>
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (titular.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
        terceros.some(tercero =>
          tercero.documento === titular.terceroId &&
          tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
        )) &&
      (!searchStartDate || new Date(titular.fecha) >= new Date(searchStartDate)) &&
      (!searchEndDate || new Date(titular.fecha) <= new Date(searchEndDate)) &&
      titular.sepulturaId.toString().includes(searchSepulturaId) // <-- esta línea nueva
    );
    setFilteredTitulares(filtered);
  };
  


/*
  const filterTitulares = () => {
    let filtered = titulares.filter(titular =>
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (titular.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === titular.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )) &&
      (!searchStartDate || new Date(titular.fecha) >= new Date(searchStartDate)) &&
      (!searchEndDate || new Date(titular.fecha) <= new Date(searchEndDate))
    );
    setFilteredTitulares(filtered);
  };
*/
  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este titular?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/titulares/${id}`);
        fetchTitulares();
      } catch (err) {
        setError('Error al eliminar el titular. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTitulares.slice(indexOfFirstItem, indexOfLastItem);
  
  const totalPages = Math.ceil(filteredTitulares.length / itemsPerPage);
  //const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  
  const startPage = pageBlock * pagesPerBlock;
  const endPage = Math.min(startPage + pagesPerBlock, totalPages);
  const pageNumbers = Array.from({ length: endPage - startPage }, (_, i) => startPage + i + 1);
  


  /*
  const totalPages = Math.ceil(filteredTitulares.length / itemsPerPage);
  const currentItems = filteredTitulares.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
*/

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Titulares</h1>
      
      <div className="flex justify-between mb-4">

   <div className="relative space-y-2 w-full">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}
  </div>


 {/*}       
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
   */}     
        <Link to="/home/titulares/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Titular
        </Link>
      </div>

      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
              type="text"
              placeholder="Buscar por Sepultura ID"
              className="border p-2 rounded w-1/5"
              value={searchSepulturaId}
              onChange={(e) => setSearchSepulturaId(e.target.value)}
          />

          <input
            type="date"
            placeholder="Fecha inicio"
            className="border p-2 rounded w-1/5"
            value={searchStartDate}
            onChange={(e) => setSearchStartDate(e.target.value)}
          />
          <input
            type="date"
            placeholder="Fecha fin"
            className="border p-2 rounded w-1/5"
            value={searchEndDate}
            onChange={(e) => setSearchEndDate(e.target.value)}
          />




        </div>

        
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((titular) => (
              <tr key={titular.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{titular.id}</td>
                <td className="px-6 py-4">{titular.fecha}</td>
                <td className="px-6 py-4">{titular.terceroId}</td>
                <td className="px-6 py-4">{titular.sepulturaId}</td>
                <td className="px-6 py-4">{titular.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/titulares/${titular.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/titulares/edit/${titular.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(titular.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>


        <div className="flex justify-center items-center mt-4 space-x-2">
  {pageBlock > 0 && (
    <button
      onClick={() => setPageBlock(pageBlock - 1)}
      className="px-4 py-2 rounded bg-gray-400 text-white"
    >
      ← Anteriores
    </button>
  )}
  {pageNumbers.map((number) => (
    <button
      key={number}
      onClick={() => setCurrentPage(number)}
      className={`px-4 py-2 rounded ${currentPage === number ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
    >
      {number}
    </button>
  ))}
  {(pageBlock + 1) * pagesPerBlock < totalPages && (
    <button
      onClick={() => setPageBlock(pageBlock + 1)}
      className="px-4 py-2 rounded bg-gray-400 text-white"
    >
      Siguientes →
    </button>
  )}
</div>


        {/*
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>{number + 1}</button>
          ))}
        </div>
        */}
      </div>
    </div>
  );
}



/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TitularesTable() {
  const [titulares, setTitulares] = useState([]);
  const [filteredTitulares, setFilteredTitulares] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTercero, setSelectedTercero] = useState(null);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchTitulares();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterTitulares();
  }, [searchTerm, searchTercero, searchStartDate, searchEndDate, titulares]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchTitulares = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/titulares');
      setTitulares(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los titulares. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterTitulares = () => {
    let filtered = titulares.filter(titular =>
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (titular.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === titular.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )) &&
      (!searchStartDate || new Date(titular.fecha) >= new Date(searchStartDate)) &&
      (!searchEndDate || new Date(titular.fecha) <= new Date(searchEndDate))
    );
    setFilteredTitulares(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este titular?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/titulares/${id}`);
        fetchTitulares();
      } catch (err) {
        setError('Error al eliminar el titular. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const totalPages = Math.ceil(filteredTitulares.length / itemsPerPage);
  const currentItems = filteredTitulares.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Titulares</h1>
      
      <div className="flex justify-between mb-4">

   <div className="relative space-y-2 w-full">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}
  </div>

        <Link to="/home/titulares/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Titular
        </Link>
      </div>

      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="date"
            placeholder="Fecha inicio"
            className="border p-2 rounded w-1/5"
            value={searchStartDate}
            onChange={(e) => setSearchStartDate(e.target.value)}
          />
          <input
            type="date"
            placeholder="Fecha fin"
            className="border p-2 rounded w-1/5"
            value={searchEndDate}
            onChange={(e) => setSearchEndDate(e.target.value)}
          />
        </div>
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((titular) => (
              <tr key={titular.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{titular.id}</td>
                <td className="px-6 py-4">{titular.fecha}</td>
                <td className="px-6 py-4">{titular.terceroId}</td>
                <td className="px-6 py-4">{titular.sepulturaId}</td>
                <td className="px-6 py-4">{titular.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/titulares/${titular.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/titulares/edit/${titular.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(titular.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>{number + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TitularesTable() {
  const [titulares, setTitulares] = useState([]);
  const [filteredTitulares, setFilteredTitulares] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchTitulares();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterTitulares();
  }, [searchTerm, searchTercero, searchStartDate, searchEndDate, titulares]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchTitulares = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/titulares');
      setTitulares(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los titulares. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterTitulares = () => {
    let filtered = titulares.filter(titular =>
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (titular.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === titular.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )) &&
      (!searchStartDate || new Date(titular.fecha) >= new Date(searchStartDate)) &&
      (!searchEndDate || new Date(titular.fecha) <= new Date(searchEndDate))
    );
    setFilteredTitulares(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este titular?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/titulares/${id}`);
        fetchTitulares();
      } catch (err) {
        setError('Error al eliminar el titular. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const totalPages = Math.ceil(filteredTitulares.length / itemsPerPage);
  const currentItems = filteredTitulares.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Titulares</h1>
      
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        
        <Link to="/home/titulares/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Titular
        </Link>
      </div>

      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="date"
            placeholder="Fecha inicio"
            className="border p-2 rounded w-1/5"
            value={searchStartDate}
            onChange={(e) => setSearchStartDate(e.target.value)}
          />
          <input
            type="date"
            placeholder="Fecha fin"
            className="border p-2 rounded w-1/5"
            value={searchEndDate}
            onChange={(e) => setSearchEndDate(e.target.value)}
          />
        </div>
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((titular) => (
              <tr key={titular.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{titular.id}</td>
                <td className="px-6 py-4">{titular.fecha}</td>
                <td className="px-6 py-4">{titular.terceroId}</td>
                <td className="px-6 py-4">{titular.sepulturaId}</td>
                <td className="px-6 py-4">{titular.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/titulares/${titular.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/titulares/edit/${titular.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(titular.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>{number + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/* CORRECTO FECHA PERO EN LA PRIMERA LINEA
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TitularesTable() {
  const [titulares, setTitulares] = useState([]);
  const [filteredTitulares, setFilteredTitulares] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchTitulares();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterTitulares();
  }, [searchTerm, searchTercero, searchStartDate, searchEndDate, titulares]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchTitulares = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/titulares');
      setTitulares(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los titulares. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterTitulares = () => {
    let filtered = titulares.filter(titular =>
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (titular.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === titular.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )) &&
      (!searchStartDate || new Date(titular.fecha) >= new Date(searchStartDate)) &&
      (!searchEndDate || new Date(titular.fecha) <= new Date(searchEndDate))
    );
    setFilteredTitulares(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este titular?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/titulares/${id}`);
        fetchTitulares();
      } catch (err) {
        setError('Error al eliminar el titular. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const totalPages = Math.ceil(filteredTitulares.length / itemsPerPage);
  const currentItems = filteredTitulares.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Titulares</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="date"
            placeholder="Fecha inicio"
            className="border p-2 rounded w-1/3"
            value={searchStartDate}
            onChange={(e) => setSearchStartDate(e.target.value)}
          />
          <input
            type="date"
            placeholder="Fecha fin"
            className="border p-2 rounded w-1/3"
            value={searchEndDate}
            onChange={(e) => setSearchEndDate(e.target.value)}
          />
        </div>
      </div>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        
        <Link to="/home/titulares/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Titular
        </Link>
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((titular) => (
              <tr key={titular.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{titular.id}</td>
                <td className="px-6 py-4">{titular.fecha}</td>
                <td className="px-6 py-4">{titular.terceroId}</td>
                <td className="px-6 py-4">{titular.sepulturaId}</td>
                <td className="px-6 py-4">{titular.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/titulares/${titular.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/titulares/edit/${titular.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(titular.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>{number + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/* CORRECTO CON PAGINACIÓN Y BÚSQUEDA
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TitularesTable() {
  const [titulares, setTitulares] = useState([]);
  const [filteredTitulares, setFilteredTitulares] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchTitulares();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterTitulares();
  }, [searchTerm, searchTercero, titulares]);

  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);

  const fetchTitulares = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/titulares');
      setTitulares(response.data.sort((a, b) => b.id - a.id));
    } catch (err) {
      setError('Error al cargar los titulares. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterTitulares = () => {
    let filtered = titulares.filter(titular =>
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (titular.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === titular.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      ))
    );
    setFilteredTitulares(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este titular?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/titulares/${id}`);
        fetchTitulares();
      } catch (err) {
        setError('Error al eliminar el titular. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const totalPages = Math.ceil(filteredTitulares.length / itemsPerPage);
  const currentItems = filteredTitulares.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Titulares</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por observaciones"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/titulares/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Titular
        </Link>
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Sepultura ID</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((titular) => (
              <tr key={titular.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{titular.id}</td>
                <td className="px-6 py-4">{titular.fecha}</td>
                <td className="px-6 py-4">{titular.terceroId}</td>
                <td className="px-6 py-4">{titular.sepulturaId}</td>
                <td className="px-6 py-4">{titular.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/titulares/${titular.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/titulares/edit/${titular.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handleDelete(titular.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
          {[...Array(totalPages).keys()].map(number => (
            <button key={number + 1} onClick={() => setCurrentPage(number + 1)} className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>{number + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TitulareTable() {
  const [titulare, setTitulare] = useState([]);
  const [filteredTitulare, setFilteredTitulare] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('id');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchTitulare();
  }, []);

  useEffect(() => {
    filterAndSortTitulare();
  }, [searchTerm, titulare, sortColumn, sortDirection]);

  const fetchTitulare = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/titulares');
      setTitulare(response.data);
      setFilteredTitulare(response.data);
    } catch (err) {
      setError('Error al cargar los titulares. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterAndSortTitulare = () => {
    let filtered = titulare.filter(titular => 
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) ||
      titular.terceroId.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredTitulare(sorted);
    setCurrentPage(1);
  };

  const handleDeleteTitular = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este titular?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/titulares/${id}`);
        fetchTitulare();
      } catch (err) {
        setError('Error al eliminar el titular. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSort = (column) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(column);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTitulare.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredTitulare.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Titulares</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="p-4 flex justify-between items-center bg-gray-50">
          <h2 className="text-xl font-semibold">Tabla de Titulares</h2>
          <Link
            to="/home/titulares/add"
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center"
          >
            <FaPlus className="mr-2" /> Añadir Titular
          </Link>
        </div>
        <div className="p-4 flex items-center bg-gray-100">
          <FaSearch className="mr-2" />
          <input
            type="text"
            placeholder="Buscar por tercero"
            className="border p-2 rounded w-64"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-blue-500 text-white">
              <tr>
                {['id', 'terceroId', 'fecha', 'observaciones', 'sepulturaId'].map((col) => (
                  <th
                    key={col}
                    className="px-6 py-3 cursor-pointer"
                    onClick={() => handleSort(col)}
                  >
                    {col.charAt(0).toUpperCase() + col.slice(1)}{' '}
                    {sortColumn === col &&
                      (sortDirection === 'asc' ? (
                        <FaSortAmountUp />
                      ) : (
                        <FaSortAmountDown />
                      ))}
                  </th>
                ))}
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((titular) => (
                <tr key={titular.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{titular.id}</td>
                  <td className="px-6 py-4">{titular.terceroId}</td>
                  <td className="px-6 py-4">{titular.fecha}</td>
                  <td className="px-6 py-4">{titular.observaciones}</td>
                  <td className="px-6 py-4">{titular.sepulturaId}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link
                      to={`/home/titulares/${titular.id}`}
                      className="text-blue-600 hover:text-blue-900"
                    >
                      <FaEye />
                    </Link>
                    <Link
                      to={`/home/titulares/edit/${titular.id}`}
                      className="text-green-600 hover:text-green-900"
                    >
                      <FaEdit />
                    </Link>
                    <button
                      onClick={() => handleDeleteTitular(titular.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 border rounded ${
                currentPage === index + 1
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200'
              }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TitulareTable() {
  const [titulare, setTitulare] = useState([]);
  const [filteredTitulare, setFilteredTitulare] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('terceroId');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchTitulare();
  }, []);

  useEffect(() => {
    filterAndSortTitulare();
  }, [searchTerm, titulare, sortColumn, sortDirection]);

  const fetchTitulare = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/titulares');
      setTitulare(response.data);
      setFilteredTitulare(response.data);
    } catch (err) {
      setError('Error al cargar los titulares. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterAndSortTitulare = () => {
    let filtered = titulare.filter(titular => 
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase()) ||
      titular.terceroId.toString().toLowerCase().includes(searchTerm.toLowerCase()) // Nueva condición para buscar por terceroId
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredTitulare(sorted);
    setCurrentPage(1);
  };

  const handleDeleteTitular = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este titular?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/titulares/${id}`);
        fetchTitulare();
      } catch (err) {
        setError('Error al eliminar el titular. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSort = (column) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(column);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTitulare.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredTitulare.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Titulares</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="p-4 flex justify-between items-center bg-gray-50">
          <h2 className="text-xl font-semibold">Tabla de Titulares</h2>
          <Link
            to="/home/titulares/add"
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center"
          >
            <FaPlus className="mr-2" /> Añadir Titular
          </Link>
        </div>
        <div className="p-4 flex items-center bg-gray-100">
          <FaSearch className="mr-2" />
          <input
            type="text"
            placeholder="Buscar por tercero "
            className="border p-2 rounded w-64"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-blue-500 text-white">
              <tr>
                {['terceroId', 'fecha', 'observaciones', 'sepulturaId'].map((col) => (
                  <th
                    key={col}
                    className="px-6 py-3 cursor-pointer"
                    onClick={() => handleSort(col)}
                  >
                    {col.charAt(0).toUpperCase() + col.slice(1)}{' '}
                    {sortColumn === col &&
                      (sortDirection === 'asc' ? (
                        <FaSortAmountUp />
                      ) : (
                        <FaSortAmountDown />
                      ))}
                  </th>
                ))}
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((titular) => (
                <tr key={titular.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{titular.terceroId}</td>
                  <td className="px-6 py-4">{titular.fecha}</td>
                  <td className="px-6 py-4">{titular.observaciones}</td>
                  <td className="px-6 py-4">{titular.sepulturaId}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link
                      to={`/home/titulares/${titular.id}`}
                      className="text-blue-600 hover:text-blue-900"
                    >
                      <FaEye />
                    </Link>
                    <Link
                      to={`/home/titulares/edit/${titular.id}`}
                      className="text-green-600 hover:text-green-900"
                    >
                      <FaEdit />
                    </Link>
                    <button
                      onClick={() => handleDeleteTitular(titular.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 border rounded ${
                currentPage === index + 1
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200'
              }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaEye, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function TitulareTable() {
  const [titulare, setTitulare] = useState([]);
  const [filteredTitulare, setFilteredTitulare] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState('terceroId');
  const [sortDirection, setSortDirection] = useState('desc');

  useEffect(() => {
    fetchTitulare();
  }, []);

  useEffect(() => {
    filterAndSortTitulare();
  }, [searchTerm, titulare, sortColumn, sortDirection]);

  const fetchTitulare = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/titulares');
      setTitulare(response.data);
      setFilteredTitulare(response.data);
    } catch (err) {
      setError('Error al cargar los titulares. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterAndSortTitulare = () => {
    let filtered = titulare.filter(titular =>
      titular.observaciones.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredTitulare(sorted);
    setCurrentPage(1);
  };

  const handleDeleteTitular = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este titular?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/titulares/${id}`);
        fetchTitulare();
      } catch (err) {
        setError('Error al eliminar el titular. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleSort = (column) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(column);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTitulare.slice(indexOfFirstItem, indexOfLastItem);

const totalPages = Math.ceil(filteredTitulare.length / itemsPerPage);
const paginate = (pageNumber) => setCurrentPage(pageNumber);

return (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Titulares</h1>
    <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
      <div className="p-4 flex justify-between items-center bg-gray-50">
        <h2 className="text-xl font-semibold">Tabla de Titulares</h2>
        <Link
          to="/home/titulares/add"
          className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center"
        >
          <FaPlus className="mr-2" /> Añadir Titular
        </Link>
      </div>
      <div className="p-4 flex items-center bg-gray-100">
        <FaSearch className="mr-2" />
        <input
          type="text"
          placeholder="Buscar por Observaciones"
          className="border p-2 rounded w-64"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              {['terceroId', 'fecha', 'observaciones', 'sepulturaId'].map((col) => (
                <th
                  key={col}
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort(col)}
                >
                  {col.charAt(0).toUpperCase() + col.slice(1)}{' '}
                  {sortColumn === col &&
                    (sortDirection === 'asc' ? (
                      <FaSortAmountUp />
                    ) : (
                      <FaSortAmountDown />
                    ))}
                </th>
              ))}
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((titular) => (
              <tr key={titular.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{titular.terceroId}</td>
                <td className="px-6 py-4">{titular.fecha}</td>
                <td className="px-6 py-4">{titular.observaciones}</td>
                <td className="px-6 py-4">{titular.sepulturaId}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link
                    to={`/home/titulares/${titular.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye />
                  </Link>
                  <Link
                    to={`/home/titulares/edit/${titular.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit />
                  </Link>
                  <button
                    onClick={() => handleDeleteTitular(titular.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center space-x-2 mt-4">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => paginate(index + 1)}
            className={`px-4 py-2 border rounded ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  </div>
);
}
*/
  /*
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTitulare.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredTitulare.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Titulares</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="p-4 flex justify-between items-center bg-gray-50">
          <h2 className="text-xl font-semibold">Tabla de Titulares</h2>
          <Link to="/home/titulares/add" className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
            <FaPlus className="mr-2" /> Añadir Titular
          </Link>
        </div>
        <div className="p-4 flex items-center bg-gray-100">
          <FaSearch className="mr-2" />
          <input
            type="text"
            placeholder="Buscar por Observaciones"
            className="border p-2 rounded w-64"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                {['terceroId', 'fecha', 'observaciones', 'sepulturaId'].map(col => (
                  <th key={col} className="px-6 py-3 cursor-pointer" onClick={() => handleSort(col)}>
                    {col.charAt(0).toUpperCase() + col.slice(1)} {sortColumn === col && (sortDirection === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                  </th>
                ))}
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((titular) => (
                <tr key={titular.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{titular.terceroId}</td>
                  <td className="px-6 py-4">{titular.fecha}</td>
                  <td className="px-6 py-4">{titular.observaciones}</td>
                  <td className="px-6 py-4">{titular.sepulturaId}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link to={`/home/titulares/${titular.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                    <Link to={`/home/titulares/edit/${titular.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                    <button onClick={() => handleDeleteTitular(titular.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(totalPages)].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={`px-4 py-2 border rounded ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}>{index + 1}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
*/

/*import React, { useEffect, useState } from 'react';
import axios from 'axios';

const TitularList = () => {
  const [titulares, setTitulares] = useState([]);
  const [search, setSearch] = useState('');
  const [filteredTitulares, setFilteredTitulares] = useState([]);
  const [editTitular, setEditTitular] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const [newTitular, setNewTitular] = useState({
    cementerioId: '',
    terceroId: '',
    fecha: '',
    observaciones: '',
    sepulturaId: ''
  });

  useEffect(() => {
    axios.get('http://localhost:3000/titulares')
      .then(response => {
        setTitulares(response.data);
        setFilteredTitulares(response.data);
      })
      .catch(error => {
        console.error('Error fetching titulares:', error);
      });
  }, []);

  useEffect(() => {
    setFilteredTitulares(
      titulares.filter(titular =>
        (titular.terceroId ? titular.terceroId.toString().toLowerCase() : '').includes(search.toLowerCase())
      )
    );
    setCurrentPage(1);
  }, [search, titulares]);

  const handleEdit = (titular) => {
    setEditTitular(titular);
    setNewTitular(titular);
  };

  const handleSave = () => {
    axios.put(`http://localhost:3000/titulares/${editTitular.id}`, newTitular)
      .then(response => {
        setTitulares(titulares.map(t => t.id === editTitular.id ? response.data : t));
        setFilteredTitulares(filteredTitulares.map(t => t.id === editTitular.id ? response.data : t));
        setEditTitular(null);
      })
      .catch(error => {
        console.error('Error updating titular:', error);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar este titular?')) {
      axios.delete(`http://localhost:3000/titulares/${id}`)
        .then(() => {
          setTitulares(titulares.filter(t => t.id !== id));
          setFilteredTitulares(filteredTitulares.filter(t => t.id !== id));
        })
        .catch(error => {
          console.error('Error deleting titular:', error);
        });
    }
  };

  const handleAdd = () => {
    const { sepulturaId, ...data } = newTitular;

    if (!sepulturaId) {
      alert('Debe ingresar un ID de sepultura antes de grabar.');
      return;
    }

    axios.post(`http://localhost:3000/titulares/${sepulturaId}`, data)
      .then(response => {
        setTitulares([...titulares, response.data]);
        setFilteredTitulares([...filteredTitulares, response.data]);
        setNewTitular({ cementerioId: '', terceroId: '', fecha: '', observaciones: '', sepulturaId: '' });
      })
      .catch(error => {
        console.error('Error adding titular:', error);
      });
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredTitulares.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredTitulares.length / recordsPerPage);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Lista de Titulares</h1>
      <input
        type="text"
        placeholder="Buscar por Tercero ID"
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ marginBottom: '20px', padding: '10px', width: '100%' }}
      />
      
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>ID</th><th>Tercero ID</th><th>Fecha</th><th>Observaciones</th><th>ID Sepultura</th><th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map(titular => (
            <tr key={titular.id}>
              <td>{titular.id}</td>
              <td>{titular.terceroId}</td>
              <td>{titular.fecha}</td>
              <td>{titular.observaciones}</td>
              <td>{titular.sepulturaId}</td>
              <td>
                <button onClick={() => handleEdit(titular)}>✏️</button>
                <button onClick={() => handleDelete(titular.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div>
        <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>◀ Anterior</button>
        <span> Página {currentPage} de {totalPages} </span>
        <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>Siguiente ▶</button>
      </div>

      <h2>Añadir Nuevo Titular</h2>
      {Object.keys(newTitular).map(key => (
        <input
          key={key}
          type="text"
          placeholder={key}
          value={newTitular[key]}
          onChange={e => setNewTitular({ ...newTitular, [key]: e.target.value })}
          style={{ margin: '5px', padding: '10px' }}
        />
      ))}
      <button onClick={handleAdd} style={{ padding: '10px', backgroundColor: 'green', color: 'white' }}>➕ Grabar</button>
    </div>
  );
};

export default TitularList;
*/